import { render, staticRenderFns } from "./InspectionAnomalies.vue?vue&type=template&id=1a92d0d3&scoped=true&"
import script from "./InspectionAnomalies.vue?vue&type=script&lang=ts&"
export * from "./InspectionAnomalies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a92d0d3",
  null
  
)

export default component.exports